import { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ToastContainer, ToastContainerProps } from 'react-toastify';
import ReactHowler from 'react-howler';
import { Loader, SoundBG, useSounds } from '@outdoria/ui';

import { useAppContext } from './utils/context';
import {
  AuthView,
  AwaitingApprovalView,
  BannedView,
  HomeView,
  LoadingView,
  LoginView,
  NotImplementedView,
  SignInView,
} from './pages';

import { App } from './App';

export const Router = () => {
  const { music, setMusic, isMusicPlaying, musicVolume } = useAppContext();
  const { changeMusic } = useSounds(setMusic);

  useEffect(() => {
    const isInsideInstalledApp =
      window.matchMedia('(display-mode: standalone)').matches || // @ts-ignore
      window.navigator.standalone === true;
    if (isInsideInstalledApp) {
      // Size window after open the app
      window.resizeTo(400, 800);
    }
  }, []);

  useEffect(() => {
    changeMusic(SoundBG.SNOW_AND_CHILDREN);
  }, []);

  const router = createBrowserRouter([
    {
      path: '/auth',
      element: <AuthView />,
      children: [
        // AUTH ROUTES
        { path: '/auth/loading', element: <LoadingView /> },
        { path: '/auth/login', element: <LoginView /> },
        { path: '/auth/signin', element: <SignInView /> },
        { path: '/auth/ban', element: <BannedView /> },
        { path: '/auth/awaiting', element: <AwaitingApprovalView /> },
      ],
    },
    // INTERACTIVE PATHS
    {
      path: '/',
      element: <App />,
      children: [
        {
          path: '/',
          element: <HomeView />,
        },
        // STATIC PATHS
        {
          path: '/404',
          element: <NotImplementedView />,
        },
        {
          path: '*',
          element: <NotImplementedView />,
        },
      ],
    },
  ]);

  return (
    <>
      {music && (
        <ReactHowler
          src={music}
          playing={isMusicPlaying}
          volume={musicVolume}
          loop
        />
      )}
      <ToastContainer {...toastOptions} />
      <RouterProvider router={router} fallbackElement={<Loader />} />
    </>
  );
};

const toastOptions: ToastContainerProps = {
  closeOnClick: true,
  theme: 'dark',
  autoClose: 2500,
  limit: 3,
  style: { fontSize: '16px', fontWeight: 400 },
};
